<template>
  <v-tabs v-model="tab" show-arrows background-color="colorDominant colorTabs">
    <template v-for="(day, index) in days">
      <v-tab :key="day" @click="getByDay(index, true)" :disabled="tabDisabled">
        {{ formatDateTabs(day) }}
      </v-tab>
    </template>
  </v-tabs>
</template>

<script>
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

export default {
  name: "toolbar-tab-days",
  data: () => {
    return {
      // active: "tab-0",
      days: [],
      tab: null,
      tabDisabled: false,
    };
  },
  async mounted() {
    this.$root.$on('advanceTab', () => {
      this.$nextTick(() => {
        this.tab += 1;
        this.getByDay(this.tab, false);
      });
    });
    // const _this = this;
    // // document.addEventListener("visibilitychange", function() {
    // //   _this.active = "tab-0";
    // // });

    await this.handleTableDays();
  },
  computed: {
    // days() {
    //   const date = new Date();
    //   const lengthCurrentMonth = `${date.getMonth() + 1}`.split("").length;
    //   const valueMonth =
    //     lengthCurrentMonth == 1
    //       ? `0${date.addDays(1).getMonth() + 1}`
    //       : `${date.addDays(2).getMonth() + 1}`;
    //   const days = [
    //     { name: "Hoje", value: 0, active: true },
    //     {
    //       name: `${date.addDays(1).getDate()}/${valueMonth}`,
    //       value: 1,
    //       active: false,
    //     },
    //     {
    //       name: `${date.addDays(2).getDate()}/${valueMonth}`,
    //       value: 2,
    //       active: false,
    //     },
    //   ];
    //   return days;
    // },
    // Table Days
    tableDays() {
      return this.$store.state.operators.table_days;
    },
  },

  watch: {
    days(days) {
      this.$emit("updateDays", days);
    },
  },

  methods: {
    getByDay: function(n_days, userClick) {
      this.$emit("rungetdata", n_days, userClick);
    },

    handleTableDays() {
      var numberDays = Number(this.tableDays); // Table Days
      this.days = []; // array

      // Util para incr. ou decrementar horas
      Date.prototype.addHours = function(value) {
        this.setHours(this.getHours() + value);
      };

      // Push Today "HOJE" in array;
      var today = new Date();
      today.addHours(-3);
      today = new Date(today).toISOString().slice(0, -14);
      this.days.push(today);

      // Push table days in array;
      for (var i = 1; i < numberDays; i++) {
        // Incrementa
        var newDate = new Date().toDateString();
        var date = new Date(newDate);
        var day = date.setDate(date.getDate() + i);
        // Formata
        var formatDay = new Date(new Date(day).setHours(-3, 0, 0))
          .toISOString()
          .slice(0, -14);
        // Push in array
        this.days.push(formatDay);
      }
    },
    formatDateTabs(date) {
      Date.prototype.addHours = function(value) {
        this.setHours(this.getHours() + value);
      };

      // Push Today "HOJE" in array;
      var today = new Date();
      today.addHours(-3);
      today = new Date(today).toISOString().slice(0, -14);

      // if HOJE
      var dateTab = new Date(date).toISOString().slice(0, -14);

      if (dateTab === today) {
        return this.$t("today");
      }

      // if AMANHÃ
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (date === tomorrow.toISOString().slice(0, -14)) {
        return this.$t("tomorrow");
      }

      // FORMAT DATE FOR UI
      var formatDate = new Date(`${date}T00:00:00`)
        .toLocaleDateString()
        .slice(0, -5);
      return formatDate;
    },
  },
  filters: {},
};
</script>
